/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavedViewFilter {
    getFixupPrototypeFunction() { return SavedViewFilter.fixupPrototype; }

    static newInstance(model: Partial<SavedViewFilter>): SavedViewFilter {
        let obj = Object.assign(new SavedViewFilter(), model);
        SavedViewFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavedViewFilter>): SavedViewFilter {
        if (!model) return null;
        return SavedViewFilter.newInstance(<SavedViewFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavedViewFilter) {
        if (!obj) return;

        models.SavedViewFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavedViewFilter): boolean {
        Object.setPrototypeOf(obj, SavedViewFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Optional dashboard filter
     */
    dashboard_id: string;

    module: models.SavedViewModule;

    visibility: models.SavedViewVisibility;

}
